"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var HoverSVG_1 = __importDefault(require("./HoverSVG"));
var ItemsComponents = function (props) {
    var imgUrl = props.imgUrl, hoverImgUrl = props.hoverImgUrl, title = props.title, describe = props.describe, link = props.link;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(HoverSVG_1.default, { enterUrl: hoverImgUrl || imgUrl, leaveUrl: imgUrl }),
        react_1.default.createElement("a", { href: link, className: "list__block" },
            react_1.default.createElement("strong", { className: "list__title" }, title),
            react_1.default.createElement("span", { className: "list__describe" }, describe))));
};
exports.default = ItemsComponents;
//# sourceMappingURL=Items.js.map